import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18" {...props}><path fill="#CACACA" fillRule="evenodd" id="$" d="M1.8 5.88H0v3.08h1.8V18h3.48V8.92h2.43l.25-3.03H5.29V4.14c0-.71.14-1 .8-1h1.88V0h-2.4C2.97 0 1.81 1.19 1.81 3.46V5.9" /></svg>);